import { createContext, useContext, useState } from "react";
import { ETransactionType, TransactionTypeNames } from "../shared/ITransaction";

const FILTER_ACTIONS = Array.from(TransactionTypeNames.keys())

interface IActionFilterProviderContext {
    actions:ETransactionType[]
    setActions:(actions:ETransactionType[]) => void
}
const ActionFilterContext = createContext<IActionFilterProviderContext>({actions:[],setActions:()=>{}})
const useActionFilter = () => useContext(ActionFilterContext)

export {FILTER_ACTIONS}
export default useActionFilter

export function ActionFilterProvider(props:{children:any}){
    const [actions,setActions] = useState<ETransactionType[]>([...FILTER_ACTIONS])
    return <ActionFilterContext.Provider value={{actions,setActions}}>
        {props.children}
    </ActionFilterContext.Provider>
}